module.exports = __webpack_public_path__ + "img/f.44e27603.png";